module.exports = __webpack_public_path__ + "static/media/1-1-2.e6afb5b4.png";